import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

export interface SupervisiBdrsListFilter {
  tanggal_dari?: string;
  tanggal_sampai?: string;
  signed?: boolean;
  page?: number;
  per_page?: number;
}

async function list(params: SupervisiBdrsListFilter = {}) {
  const response = await http
    .getDataParam("/supervisi-bdrs", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/supervisi-bdrs/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/supervisi-bdrs", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/supervisi-bdrs/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateItems(
  id: number,
  items: Array<{
    id: number;
    hasil?: "ya" | "tidak" | "na" | null;
    masalah?: string | null;
    rekomendasi?: string | null;
  }>
) {
  const response = await http
    .putData(`/supervisi-bdrs/${id}/items`, { items })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signSupervisor(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-bdrs/${id}/sign-supervisor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKepalaUnit(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-bdrs/${id}/sign-kepala-unit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/supervisi-bdrs/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/supervisi-bdrs/${id}/pdf`, "_blank");
}

export default {
  list,
  find,
  create,
  update,
  updateItems,
  signSupervisor,
  signKepalaUnit,
  destroy,
  printPdf,
};
